

export const BaseConfigs = {
  CONTACT_SUPPORT_EMAIL : "CONTACT_SUPPORT_EMAIL"
}